module.exports = __webpack_public_path__ + "img/quato2.b8388a3b.png";